<template>
  <contact-info-form
    :name="contactName"
    :name-placeholder="$t('outboxContactNamePlaceholder')"
    :name-label="$t('outboxContactNameLabel')"
    @name-change="setContactName"
    :email="contactEmail"
    :email-placeholder="$t('outboxContactEmailPlaceholder')"
    :email-label="$t('outboxContactEmailLabel')"
    :email-error-missing="$t('outboxContactEmailFieldBlank')"
    :email-error-wrong="$t('outboxContactEmailFieldWrong')"
    @email-change="setContactEmail"
    :phone="contactPhone"
    :phone-placeholder="$t('outboxContactPhonePlaceholder')"
    :phone-label="$t('outboxContactPhoneLabel')"
    @phone-change="setContactPhone"/>
</template>

<script>
  import outbox from '@/components/outbox';
  import ContactInfoForm from '@/components/ContactInfoForm.vue';
  import { mapActions, mapGetters, mapState } from 'vuex';

  export default {
    name: 'OutboxContactInfoForm',
    computed: {
      ...mapState(outbox.store.namespace, [
        'contactName',
        'contactEmail',
        'contactPhone'
      ])
    },
    methods: {
      ...mapActions(outbox.store.namespace, [
        'setContactName',
        'setContactEmail',
        'setContactPhone'
      ]),
    },
    components: {
      ContactInfoForm
    }
  }
</script>

<style lang="scss" scoped>
</style>
